module.exports = __webpack_public_path__ + "static/media/emptyState.363179c9.png";